<div class="slide-prestation" [ngStyle]="{'width': '100%'}" (click)="findCalendar($event);">
    <div id="slide-left" *ngIf="showLeft">
        <div style="padding-left: 70px;height: 60px;">
            <div class="title-presatation"> Ajouter un Contenant </div>
        </div>
        <div class="col-sm-12" style="height:calc(100% - 70px)">
            <div class="col-sm-1" style="padding:5px;" [ngStyle]="{'margin-top': getMargin()}">
                <ul style="padding-left:0px;">
                    <li [ngClass]="{'step-active':step===1, 'step-oval':step!==1}"
                        [ngStyle]="{'background-color':step > 1 ? '#e7e7e7' : '' }">
                        {{step===1 ? '1' : ''}} </li>
                    <li [ngClass]="{'step-active':step===2, 'step-oval':step!==2}"
                        [ngStyle]="{'background-color':step > 2 ? '#e7e7e7' : '' }">
                        {{step===2 ? '2' : ''}} </li>
                    <li [ngClass]="{'step-active':step===3, 'step-oval':step!==3}"
                        [ngStyle]="{'background-color':step > 3 ? '#e7e7e7' : '' }">
                        {{step===3 ? '3' : ''}} </li>
                    <li [ngClass]="{'step-active':step===4, 'step-oval':step!==4}"
                        [ngStyle]="{'background-color':step > 4 ? '#e7e7e7' : '' }">
                        {{step===4 ? '4' : ''}} </li>
                    <li [ngClass]="{'step-active':step===5, 'step-oval':step!==5}"
                        [ngStyle]="{'background-color':step > 5 ? '#e7e7e7' : '' }">
                        {{step===5 ? '5' : ''}} </li>
                </ul>
            </div>
            <div class="col-sm-11" style="height:100%;">
                <div class="text-left uppercase btn-nav" *ngIf="!edit" (click)="prevStep()">
                    <img src="assets/images/icons/fleche-precedent.svg" alt="precedent" /> Précédent
                </div>
                <div class="add-prestation" [ngSwitch]="step">
                    <div class="col-sm-12" style="padding: 5px; height:100%">
                        <div *ngSwitchCase="1" class="etape1">
                            <div style="margin-bottom: 20px">
                                <span class="step-title">Recherchez le client</span>
                            </div>
                            <div class="form-group">
                                <app-autocomplete *ngIf="!newprest.showcombo"
                                    [placeholder]="'Nom et prénom du client *'" (searchfunction)="searchClient($event)"
                                    (selectfunction)="setValue($event, 'client')" [defaultselected]="newprest.client"
                                    [results]="dataClient" [label]="'Nom et prénom du client *'" id="clientCt"
                                    [defaultsearch]="newprest.client ? newprest.client.libelleObjetEntite : ''"
                                    [minlength]="3"></app-autocomplete>
                            </div>
                            <label class="text" style=" margin-top: 15px;padding-left: 0px;"
                                (click)="showFicheCltadd()">
                                Voulez-vous
                                <span class='text-underline uppercase'>creer un Client</span> ?</label>
                            <div class="uppercase" [ngStyle]="{'margin': newprest.showcombo ? '20px 0px' : '80px 0px'}">
                                <button class="btn-ok"
                                    (click)="newprest.client ? nextStep() : setValue($event, 'client')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="2" class="etape2">
                            <div style="margin-bottom: 15px">
                                <span class="step-title"> Choix de la ville </span>
                            </div>
                            <div class="form-group">
                                <app-autocomplete [placeholder]="'Ville'" (searchfunction)="searchVille($event)"
                                    (selectfunction)="setValue($event, 'chantierVille');" id="villeCt"
                                    [defaultselected]="newprest.chantierVille" [results]="listChantierVille" [label]="'Ville'"
                                    [defaultsearch]="newprest.chantierVille ? (newprest.chantierVille.ville ) : ''" [autoshow]="true">
                                </app-autocomplete>
                            </div>

                            <div class="uppercase" style="margin: 80px 0px;;">
                                <button class="btn-ok" (click)="setValue(selectedChantier, 'chantierVille')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="3" class="etape2">
                            <div style="margin-bottom: 15px">
                                <span class="step-title">Sélectionnez le chantier</span>
                            </div>
                            <div class="form-group">
                                <app-autocomplete [placeholder]="'Chantier *'" (searchfunction)="searchChantier($event)"
                                    (selectfunction)="setValue($event, 'chantier'); selectedChantier = $event;"
                                    [defaultselected]="newprest.chantier" [results]="listChantier"
                                    [label]="'Chantier *'" id="chantierCt"
                                    [defaultsearch]="newprest.chantier ? newprest.chantier.numChantier : ''"
                                    [autoshow]="true"></app-autocomplete>
                            </div>
                            <label class="text" style=" margin-top: 190px;padding-left: 0px;"
                                (click)="getChantier(false)">Voulez-vous
                                <span class='text-underline uppercase'>creer un chantier</span> ?</label>
                            <div class="uppercase" style="margin: 80px 0px;;">
                                <button class="btn-ok" (click)="setValue(selectedChantier, 'chantier')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="4" class="etape3">
                            <div style="margin-bottom: 15px">
                                <span class="step-title"> Vérifier l'adresse du chantier </span>
                            </div>
                            <div class="list-group">
                                <li class="list-group-item container selected-item" id="autofocus" tabindex="0"
                                    *ngIf="selectedChantier" (keyup.enter)="setValue('test', 'adresse')"
                                    style="height: auto;">
                                    <input type="radio" class="col-sm-1" name="adresse" checked="checked" value="item">
                                    <span class="col-sm-12">
                                        <div> {{selectedChantier.numChantier || ''}} </div>
                                        <div> {{selectedChantier.adresse1 || ''}} </div>
                                        <div> {{selectedChantier.adresse2 || ''}} </div>
                                        <div> {{selectedChantier.adresse3 || ''}} </div>
                                        <div> {{ (selectedChantier.codePostal || '') +' '+ (selectedChantier.ville ||
                                            '') }} </div>
                                        <div> {{ (selectedChantier.telephone || '') }} </div>
                                    </span>
                                </li>
                            </div>
                            <label class="text" style=" margin-top: 15px;padding-left: 0px;"
                                (click)="getChantier((selectedChantier.id), true)">Voulez-vous
                                <span class='text-underline uppercase'>modifier l'adresse du chantier</span> ?</label>
                            <div class="uppercase" style="margin: 80px 0px;">
                                <button class="btn-ok" (click)="setValue('test', 'adresse')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>
                        <div *ngSwitchCase="5" class="etape4" style="height:100%">
                            <div style="margin-bottom: 15px">
                                <span class="step-title"> Choix du contenant </span>
                            </div>
                            <div style="height:100%">
                                <div class="list-group" style="overflow:auto; max-height: calc(100% - 150px);">
                                    <li class="list-group-item container" id="autofocus"
                                        (keyup)="changeFocusCont($event, i)"
                                        (keyup.enter)="setValue(selectContenant, 'contenant'); generatePrestation();"
                                        style="height: auto; padding: 5px 2px;"
                                        *ngFor="let item of listcontenant; let i = index;" tabindex="{{i}}"
                                        (click)="setValue(item, 'contenant'); generatePrestation();"
                                        [ngClass]="{'selected-item': selectContenant && selectContenant.id === item.id}">
                                        <app-contenant [item]="item" [common]="common"></app-contenant>

                                    </li>
                                    <li class="list-group-item container" id="autofocus" tabindex="0"
                                        *ngIf="!listcontenant.length" style="height: auto;">
                                        Pas de contenant
                                    </li>
                                </div>
                                <div class="uppercase" style="margin: 10px 0px;">
                                    <button class="btn-ok"
                                        (click)="setValue(selectContenant, 'contenant'); generatePrestation();">
                                        OK </button>
                                    <label>Appuyez sur
                                        <b>Entrée</b> pour valider.</label>
                                </div>
                            </div>
                        </div>
                        <!--
                        <div *ngSwitchCase="5" class="etape3">
                            <div style="margin-bottom: 15px">
                                <span class="step-title" *ngIf="!isEditContenant"> Vérifier le contenant </span>
                                <span class="step-title" *ngIf="isEditContenant"> Modification du contenant </span>
                            </div>
                            <div class="list-group" *ngIf="!isEditContenant">
                                <li class="list-group-item container selected-item" id="autofocus2" tabindex="0" *ngIf="selectedChantier"
                                    (keyup.enter)="setValue('test', 'cont')" (click)="setValue('test', 'cont')" style="height: auto;">
                                    <app-contenant *ngIf="newprest.contenant" [item]="newprest.contenant" [common]="common"></app-contenant>
                                    <app-contenant *ngIf="newprest.newBenne" [item]="newprest.newBenne" [common]="common"></app-contenant>
                                </li>
                            </div>
                            <div class="col-sm-12" *ngIf="isEditContenant" style="padding: 0;">
                                <div *ngIf="newprest.contenant">
                                    <div class="form-group">
                                        <app-autocomplete (selectfunction)="newprest.contenant.typeContenant = $event;  common.focusElement('#autocomplete')"
                                            [results]="typeContenant" [highlight]="true" [isCombo]="true" [label]="'Type contenant'"
                                            id="typecontenant" [placeholder]="'Type contenant'" [defaultselected]="newprest.contenant.typeContenant"
                                            [defaultsearch]="newprest.contenant.typeContenant ? newprest.contenant.typeContenant.libelleObjetEntite : ''"></app-autocomplete>
                                    </div>
                                    <div class="form-group">
                                        <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                                            (selectfunction)="newprest.contenant.art = $event; setValue('test', 'cont')"
                                            [results]="listArticle" [label]="'Article'" (keyenterfunction)="newprest.contenant.art ?  setValue('test', 'cont')  : false"
                                            [defaultselected]="newprest.contenant.art" [defaultsearch]="newprest.contenant.art ? newprest.contenant.art.libelleObjetEntite : ''"></app-autocomplete>
                                    </div>
                                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                                        <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                                            [(ngModel)]="newprest.contenant.isLocation" [disabled]="isVidage">
                                        <span (click)="newprest.contenant.isLocation = !newprest.contenant.isLocation"
                                            style="cursor: pointer;">
                                            Location </span>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <input type="text" class="col-sm-12 date" id="date" [ngModel]="newprest.contenant.dateDebutLoc"
                                            (ngModelChange)="newprest.contenant.dateDebutLoc = $event;" placeholder="Date debut"
                                            (click)="newprest.contenant.isLocation ? d.open() : d.close();"
                                            ngbDatepicker NgbInputDatepicker [autoClose]="false" #d="ngbDatepicker"
                                            (dateSelect)="selectDate($event, '#date')" (focus)="newprest.contenant.isLocation ? d.open(): d.close();"
                                            (keydown)="setFocuscalendar($event)" (keydown.enter)="d.close();common.changeDate($event, newprest.contenant.dateDebutLoc); setValue('test', 'cont')"
                                            autocomplete="off" [disabled]="!newprest.contenant.isLocation" [disabled]="isVidage">
                                    </div>
                                </div>
                                <div *ngIf="newprest.newBenne">
                                    <div class="form-group">
                                        <app-autocomplete (selectfunction)="newprest.newBenne.typeContenant = $event;  common.focusElement('#autocomplete')"
                                            [results]="typeContenant" [highlight]="true" [isCombo]="true" [label]="'Type contenant'"
                                            id="typecontenant" [placeholder]="'Type contenant'" [defaultselected]="newprest.newBenne.typeContenant"
                                            [defaultsearch]="newprest.newBenne.typeContenant ? newprest.newBenne.typeContenant.libelleObjetEntite : ''"></app-autocomplete>
                                    </div>
                                    <div class="form-group">
                                        <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                                            (selectfunction)="newprest.newBenne.art = $event; setValue('test', 'cont')"
                                            [results]="listArticle" [label]="'Article'" (keyenterfunction)="newprest.newBenne.art ? setValue('test', 'cont') : false"
                                            [defaultselected]="newprest.newBenne.art" [defaultsearch]="newprest.newBenne.art ? newprest.newBenne.art.libelleObjetEntite : ''"></app-autocomplete>
                                    </div>
                                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                                        <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                                            [(ngModel)]="newBenne.isLocation">
                                        <span (click)="newprest.newBenne.isLocation = !newprest.newBenne.isLocation"
                                            style="cursor: pointer;">
                                            Location </span>
                                    </div>
                                    <div class="form-group col-sm-6">
                                        <input type="text" class="col-sm-12 date" id="date" [ngModel]="newprest.newBenne.dateDebutLoc"
                                            (ngModelChange)="newprest.newBenne.dateDebutLoc = $event;" placeholder="Date debut"
                                            (click)="newprest.newBenne.isLocation ? d.open() : d.close();"
                                            ngbDatepicker NgbInputDatepicker [autoClose]="false" #d="ngbDatepicker"
                                            (dateSelect)="selectDate($event, '#date')" (focus)="newprest.newBenne.isLocation ? d.open(): d.close();"
                                            (keydown)="setFocuscalendar($event)" (keydown.enter)="d.close();common.changeDate($event, newprest.newBenne.dateDebutLoc); setValue('test', 'cont')"
                                            autocomplete="off" [disabled]="!newprest.newBenne.isLocation">
                                    </div>
                                </div>

                            </div>
                            <label class="text" *ngIf="!isEditContenant" style=" margin-top: 15px;padding-left: 0px;"
                                (click)=" modifContenant()">Voulez-vous
                                <span class='text-underline uppercase' (click)=" modifContenant() ">
                                    modifier le contenant</span> ?</label>
                            <div class="uppercase" style="margin: 80px 0px;">
                                <button class="btn-ok" (click)="setValue('test', 'cont')">
                                    OK </button>
                                <label>Appuyez sur
                                    <b>Entrée</b> pour valider.</label>
                            </div>
                        </div>-->
                    </div>
                </div>
                <div class="text-left uppercase btn-nav" *ngIf="!edit" (click)="nextStep()" style="position: absolute;">
                    <img src="assets/images/icons/fleche-suivant.svg" alt="suivant" /> Suivant
                </div>
            </div>
        </div>
    </div>
    <div id="slide-right">
        <div class="col-sm-12" style="margin-bottom:5px;">
            <button class="pull-right btn-close" id="closeSlide" (click)="closeFunction()"> Fermer </button>

        </div>
        <div class="col-sm-12" style="height: calc(100% - 160px); overflow-y: auto;">
            <div class="col-sm-12" style="padding: 0">
                <div class="col-sm-6" *ngIf="newprest.client" style="cursor: pointer; padding-top: 6px;">
                    <label> Nom du client </label>
                    <div>
                        <div class="col-sm-12" style="padding-left: 0px;"> {{ newprest.client.libelleObjetEntite }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pull-right" [ngClass]="{'div': !isVidage && !edit}" *ngIf="newprest.chantier"
                    (click)="!edit ? editEvent(newprest, 3) : false" style="cursor: pointer;">
                    <label> Nom du chantier </label>
                    <div>{{ newprest.chantier.numChantier }}</div>
                </div>

            </div>
            <div class="col-sm-12" style="padding: 0">
                <div class="col-sm-6">
                    <label *ngIf="newprest.client" class=" text-left uppercase text-underline showfiche"
                        (click)="showFiche()" style="margin-top: 7px;">
                        Voir la fiche
                    </label>
                </div>
                <div class="col-sm-6">
                    <label *ngIf="newprest.chantier" class=" text-left uppercase text-underline showfiche"
                        (click)="getChantier(newprest.chantier.id)">
                        Voir la fiche
                    </label>
                </div>
            </div>


            <div class="col-sm-12" [ngClass]="{'div': !isVidage && !edit}" *ngIf="newprest.adresse"
                (click)="!edit ? editEvent(newprest, 4) : false" style="cursor: pointer;">
                <label> Adresse </label>
                <div style="margin-bottom: 5px;">
                    {{ ((selectedChantier.numChantier|| "") +' - ' + (selectedChantier.adresse1 || "") +' - ' +
                    (selectedChantier.codePostal
                    || "") + ' ' + (selectedChantier.ville|| "") + (selectedChantier.telephone ? ' - ' +
                    selectedChantier.telephone:
                    '')) }}
                </div>
            </div>

            <div class="col-sm-12 div" *ngIf="newprest.contenant"
                (click)="edit ? modifContentContenant()  : editEvent(newprest, 5)">
                <label> Contenant </label>
                <div style="margin-bottom: 5px;">
                    <app-contenant [item]="newprest.contenant" [common]="common"></app-contenant>
                </div>
            </div>
        </div>
    </div>
    <div class="fiche" #fiche id="fiche" [ngStyle]="{'width': (showFichechantier || showFicheclt) ? '552px' : '0'}">
        <div class="ficheclt" *ngIf="showFichechantier" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-fiche-chantier [chantier]="showFichechantier" [client]="newprest.client" [edit]="isEditChantier"
                (hidefunction)="hideChantier()" (validefunction)="updateChantier($event)"
                (addfunction)="createChantier($event)" [add]="addChantier" [disablemodif]="edit"></app-fiche-chantier>
        </div>
        <div class="fichechantier" *ngIf="showFicheclt" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
            <app-fiche-client [position]="true" [client]="addClient ? '' : newprest.client.id"
                (hidefunction)="addClient ? showFicheCltadd() : showFiche()"
                (addfunction)="addClient ? afterAddClt($event) : false" [add]="addClient"></app-fiche-client>
        </div>
    </div>
</div>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg"> {{ error }} </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="closeModalError()"> Fermer </button>
        </div>
    </div>
</ng-template>